import jQuery from "jquery";
import moment from "moment";
import "moment-timezone";
import select2 from "select2";

window.jQuery = window.$ = jQuery;
window.moment = moment;

select2(window, jQuery);

import "summernote/dist/summernote-lite.js";

